<template>
    <div class="wrapper result-query">
        <div class="header">
            <div class="title">结果查询</div>
        </div>
        <div class="content">
            <div class="score-section">
                <div class="score-circle">
                    <div class="score-value">{{ resultData.score || 0 }}分</div>
                </div>
            </div>
            <div class="info-card">
                <div class="info-item">
                    <div class="info-label">姓名</div>
                    <div class="info-value">{{ resultData.name || '' }}</div>
                </div>
                <div class="info-item">
                    <div class="info-label">身份证号</div>
                    <div class="info-value">{{ resultData.id_card || '' }}</div>
                </div>
                <div class="info-item">
                    <div class="info-label">考试时间</div>
                    <div class="info-value">{{ resultData.exam_time || '' }}</div>
                </div>
                <div class="info-item">
                    <div class="info-label">用户类型</div>
                    <div class="info-value">{{ resultData.user_type || '' }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCertificateInfo } from '@/api/index'
export default {
    components: {},
    props: {},
    data() {
        return {
            resultData: {
                score: 0,
                name: '',
                id_card: '',
                exam_time: '',
                user_type: ''
            }
        };
    },
    watch: {},
    computed: {},
    created() {
        this.getData();
    },
    mounted() {},
    methods: {
        getData() {
            // 从路由参数获取 answerId（扫描二维码获取）
            const answerId = this.$route.query.id;
            if (!answerId) {
                this.$toast('缺少答卷ID');
                return;
            }
            
            this.$toast.loading({
                message: '加载中...',
                forbidClick: true
            });
            
            getCertificateInfo(answerId).then(res => {
                this.$toast.clear();
                this.resultData = {
                    score: res.data.totalScore || 0,
                    name: res.data.uname || '',
                    id_card: res.data.idCard || '',
                    exam_time: res.data.startTime || '',
                    user_type: res.data.type || ''
                };
            }).catch(err => {
                this.$toast.clear();
            });
        }
    }
};
</script>

<style scoped>
.result-query {
    min-height: 100vh;
    background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
    overflow: hidden;
}

.header {
    text-align: center;
    padding: 20px 0;
}

.title {
    font-size: 18px;
    font-weight: 500;
    color: #1B1817;
}

.content {
    margin-top: 20px;
}

.score-section {
    position: relative;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.score-section::before {
    content: '';
    position: absolute;
    width: 200px;
    height: 200px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    animation: ripple 2s ease-out infinite;
}

.score-section::after {
    content: '';
    position: absolute;
    width: 150px;
    height: 150px;
    border: 2px solid rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    animation: ripple 2s ease-out infinite 0.5s;
}

@keyframes ripple {
    0% {
        transform: scale(0.8);
        opacity: 1;
    }
    100% {
        transform: scale(1.5);
        opacity: 0;
    }
}

.score-circle {
    position: relative;
    z-index: 1;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4FC3F7 0%, #29B6F6 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(66, 100, 203, 0.3);
}

.score-value {
    font-size: 28px;
    font-weight: bold;
    color: #FFFFFF;
}

.info-card {
    margin: 20px 15px;
    background-color: #FFFFFF;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #E8E8E8;
}

.info-item:last-child {
    border-bottom: none;
}

.info-label {
    font-size: 14px;
    color: #666666;
    flex-shrink: 0;
}

.info-value {
    font-size: 14px;
    color: #1B1817;
    text-align: right;
    flex: 1;
    margin-left: 20px;
}
</style>

